import React from 'react'
import styled from 'styled-components'
import Accordion from './Accordion'
import { ecosystemList } from './list'
const PointsContainer = styled.div`
  padding: 32px;
  display: flex;
  border-radius: 16px;
  background: ${({ theme }) => theme.bg0};
  flex-direction: column;
  @media (max-width: 768px) {
    padding: 16px;
  }
`

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  h2 {
    margin-top: 0;
    margin-bottom: 24px;
    font-family: Unbounded;
    font-size: 22px;

    @media (max-width: 768px) {
      font-size: 16px;
      margin-bottom: 16px;
    }
  }

  span {
    font-size: 16px;
    color: ${({ theme }) => theme.text2};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    .referral-link {
      width: 100%;
    }
  }
`

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (max-width: 768px) {
    gap: 16px;
  }
`

const Points: React.FC<{ pointsDetails: any[]; points: number }> = ({ pointsDetails, points }) => {
  return (
    <PointsContainer>
      <HeaderContainer>
        <h2>Point details</h2>
      </HeaderContainer>
      <ListContainer>
        <Accordion
          item={{
            name: 'HyperSwap',
            total: points,
          }}
        />
        {pointsDetails
          .sort((a, b) => {
            const aDisabled = ecosystemList[a.name]?.disabled === true
            const bDisabled = ecosystemList[b.name]?.disabled === true
            if (aDisabled && !bDisabled) return 1
            if (!aDisabled && bDisabled) return -1
            return 0
          })
          .map((app: any) => {
            return <Accordion key={app.name} item={app} />
          })}
      </ListContainer>
    </PointsContainer>
  )
}

export default Points
